import React, { useState, useEffect } from 'react';
import terms from './terms.txt';

const Terms = () => {
  const [fileContent, setFileContent] = useState('');

  useEffect(() => {
    fetch(terms)
      .then((response) => response.text())
      .then((data) => setFileContent(data));
  }, []);

  const formatContent = (text) => {
    if (!text) return '';

    let isFirstTitle = true;
    return text.split('\n').map((line, index) => {
      if (line.startsWith('## ')) {
        const title = line.replace('## ', '');
        if (isFirstTitle) {
          isFirstTitle = false;
          return <h1 key={index}>{title}</h1>;
        }
        return <h2 key={index}>{title}</h2>;
      }
      if (line.includes('**')) {
        const parts = line.split('**');
        return (
          <p key={index}>
            {parts.map((part, i) => i % 2 === 1 ? <strong key={i}>{part}</strong> : part)}
          </p>
        );
      }
      if (line.trim() === '') return null;
      return <p key={index}>{line}</p>;
    });
  };

  return (
    <div className="legal-page fade-in">
      <div className="legal-page-updated">Last updated: August 10, 2024</div>
      {formatContent(fileContent)}
    </div>
  );
};

export default Terms;
